import type { ReactNode } from 'react'
import { PopupLayerContext } from './popupLayers'

/** React context follows portals, so selectors never need dialog-specific numbers. */
export function PopupLayer({ layer, children }: { layer: string; children: ReactNode }) {
  return <PopupLayerContext.Provider value={layer}>{children}</PopupLayerContext.Provider>
}
